import {
  tableState,
  tableMutations,
  tableActions,
  tableGetters
} from "@tt/vue-components";
import InventoryService from "@/services/InventoryService";
import groupFilter from "@/store/modules/storeReservationItems/filters/groupFilter";
import statusFilter from "@/store/modules/storeReservationItems/filters/statusFilter";
import skuFilter from "@/store/modules/storeReservationItems/filters/skuFilter";
import idFilter from "@/store/modules/storeReservationItems/filters/idFilter";
import emailFilter from "@/store/modules/storeReservationItems/filters/emailFilter";
import locationFilter from "@/store/modules/storeReservationItems/filters/locationFilter";

const storeReservationItems = {
  requestController: null,
  namespaced: true,
  state: {
    ...tableState,
    reservation: null,
    statistics: { total: 0 }
  },
  modules: {
    idFilter,
    skuFilter,
    groupFilter,
    statusFilter,
    emailFilter,
    locationFilter
  },
  mutations: {
    ...tableMutations,
    SET_RESERVATION(state, reservation) {
      state.reservation = reservation;
    },
    SET_STATISTICS(state, totalItems)
    {
      state.statistics = totalItems
    }
  },
  actions: {
    ...tableActions,
    async statistics(context) {
      const params ={
        pagination: {itemsPerPage: 1, page:1},
        search: [{column: "groupFilter", value: "reservation"}, {column:"status", value: "unconfirmed"}]
      };

      InventoryService.reservationItems.list(params)
        .then(json => {
          if (json) {
            context.commit("SET_STATISTICS", { total: json.totalItems ?? 0 })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchItems({ state, commit, dispatch }) {
      commit("SET_LOADING", true);

      const params = {
        pagination: state.pagination,
        sorting: state.sorting,
        search: state.search
      };

      if (this.requestController) {
        this.requestController.abort();
      }
      this.requestController = new AbortController();

      InventoryService.reservationItems.list(params, { signal: this.requestController.signal })
        .then(json => {
          if (json) {
            commit("SET_ITEMS", json);
            dispatch('statistics');
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    },
    selectReservation({commit}, item) {
      if (item !== null) {
        commit("SET_RESERVATION", item);
        commit("SET_ITEM", item);
      } else {
        commit("SET_RESERVATION", null);
        commit("SET_ITEM", null);
      }
    },
    patch({ commit }, resource) {
      return new Promise((resolve, reject) => {
        InventoryService.reservationItems.patch(resource.id, resource.body)
          .then((result) => {
            commit("EDIT_ITEM", result)
            resolve();
          })
          .catch(err => {
            console.log(err);
            reject(err["hydra:description"]);
          });
      });
    },
  },
  getters: {
    ...tableGetters
  }
};

export default storeReservationItems;
